import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ["element"];

	connect() {
		const els = this.elementTargets ?? [];
		els.forEach((el) => {
			const events = el.dataset.disableEvents?.split(" ");
			if (!events) {
				console.warn("no disabled events");

				return;
			}

			events.forEach((event) => {
				el.addEventListener(event, (e) => {
					console.log(`${event}: disabling`);
					e.preventDefault();
				}, {passive: false});
			});
		});
	}
}
